<div if.bind="ui.lightboxImage" class="lightbox" click.trigger="ui.closeLightbox()">
  <img src.bind="ui.lightboxImage" class="lightbox__img" />
</div>
